import { InactivityService } from '@/core/services/inactivityService';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {
    private inactivityService = inject(InactivityService)

    ngOnInit() {
        this.inactivityService.startMonitoring()
    }

    ngOnDestroy() {
        this.inactivityService.stopMonitoring()
    }
}
